import grey from '@mui/material/colors/grey'
import styled from "@emotion/styled";
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'

export const TableRowStyled = styled(TableRow)`
  &:nth-of-type(even) {
    background-color: #D9E1F2;
  }
  &:nth-of-type(odd) {
    background-color: #FFFFFF;
  }
`;
export const TableCellStyled = styled(TableCell)({
  fontSize: "80%",
  padding: "0 3px",
  border: "1pt solid " + grey[500],
  textAlign: "center",
 })
 export const TableHeadStyled = styled(TableCell)({
  fontSize: "80%",
  padding: "3px",
  border: "1pt solid " + grey[500],
  textAlign: "center",
  backgroundColor: "#D9E1F2",
  lineHeight: "1.2em",
})
export const TableFootStyled = styled(TableCell)({
  fontSize: "80%",
  padding: "3px",
  border: "1pt solid " + grey[500],
  textAlign: "center",
  backgroundColor:  "#F5F5F5",
  lineHeight: "1.2em",
})